const messages: Record<string, string> = {
	'onboardingStart.headline': 'Pozdrav! Provjeri svoje podatke kako bismo započeli.',
	'onboardingStart.plateNumber': 'Registarska oznaka:',
	'onboardingStart.timeout': 'Ova poveznica vrijedi do ',
	'button.start': 'Započni',
	poweredBy: 'Omogućuje <ce>ControlExpert</ce>, član <solvd>Solvd</solvd> grupe',
	'button.continue': 'Nastavi',
	'button.next': 'Nastavi',
	'review.button.next': 'Završi',
	'button.photo.take': 'Fotografiraj',
	'onboarding.headline': 'Sve je spremno za digitalni pregled?',
	'onboarding.paragraph': 'Prije početka postupka obrati pozornost na sljedeće:',
	'onboarding.documents': 'Pripremi ključeve i prometnu dozvolu vozila.',
	'onboarding.camera': 'Možeš fotografirati samo kamerom svojeg pametnog telefona.',
	'onboarding.internet': 'Odaberi dobro osvijetljeno mjesto sa stabilnom internetskom vezom.',
	'onboarding.vehicle':
		'Provjeri je li vozilo čisto, dostupno za fotografiranje iz svih kutova i jesu li svi prozori zatvoreni.',
	'onboarding.terms.before': 'Prije početka, molimo te potvrdi sljedeće:',
	'onboarding.terms.url': 'Prihvaćam Uvjete korištenja',
	'vehicleFrontLeftPerspectiveImage.title': 'Fotografija prednje lijeve dijagonale vozila',
	'vehicleFrontLeftPerspectiveImage.description':
		'Fotografiraj prednju lijevu dijagonalu vozila tako da cijelo vozilo bude vidljivo i da je jasno vidljiva registarska oznaka.',
	'vehicleRearLeftPerspectiveImage.title': 'Fotografija stražnje lijeve dijagonale vozila ',
	'vehicleRearLeftPerspectiveImage.description':
		'Fotografiraj stražnju lijevu dijagonalu vozila tako da cijelo vozilo bude vidljivo i da je jasno vidljiva registarska oznaka.',
	'vehicleRearRightPerspectiveImage.title': 'Fotografija stražnje desne dijagonale vozila ',
	'vehicleRearRightPerspectiveImage.description':
		'Fotografiraj stražnju desnu dijagonalu vozila tako da cijelo vozilo bude vidljivo i da je jasno vidljiva registarska oznaka.',
	'vehicleFrontRightPerspectiveImage.title': 'Fotografija prednje desne dijagonale vozila ',
	'vehicleFrontRightPerspectiveImage.description':
		'Fotografiraj prednju desnu dijagonalu vozila tako da cijelo vozilo bude vidljivo i da je jasno vidljiva registarska oznaka.',
	'windshieldImage.title': 'Fotografija vjetrobranskog stakla',
	'windshieldImage.description':
		'Fotografiraj vjetrobransko staklo tako da cijela površina stakla i svi detalji budu jasno vidljivi.',
	'vinPicture.title': 'Fotografija broja šasije',
	'vinPicture.description':
		'Približi kameru i fotografiraj identifikacijski broj vozila (broj šasije) tako da su svi znakovi čitljivi.',
	'button.hint': 'Gdje se nalazi broj šasije na mojem vozilu?',
	'photo.deleteConfirmation.title': 'Jeste li sigurni da želite izbrisati fotografiju?',
	'photo.deleteConfirmation.description': 'Ako izbrišete fotografiju, morat ćete snimiti novu.',
	'photo.deleteConfirmation.cancel': 'Odustani',
	'photo.deleteConfirmation.confirm': 'Izbriši fotografiju',
	'hint.vin.title': 'Gdje se može nalaziti broj šasije?',
	'hint.vin.description': 'Obično se nalazi na jednoj od sljedeće četiri lokacije:',
	'hint.vin.location1':
		'Na instrumentnoj ploči, vidljiv kroz vjetrobransko staklo s vozačeve strane.',
	'hint.vin.location2': 'Na okviru vozačevih vrata, u blizini brave.',
	'hint.vin.location3': 'U prostoru motora, najčešće na metalnoj pločici.',
	'hint.vin.location4': 'Na prednjem dijelu šasije (kod starijih vozila).',
	'overallDashboardImage.title': 'Fotografija cijele instrumentne ploče',
	'overallDashboardImage.description':
		'Fotografiraj cijelu instrumentnu ploču tako da se jasno vide sve kontrole i funkcije.',
	'dashboardMileage.title': 'Fotografija brojača kilometara',
	'vehicleMileage.description':
		'Fotografiraj brojač kilometara tako da kilometraža bude jasno vidljiva i čitljiva.',
	'dashboardMileage.paragraph.first': 'Unesi kilometražu vozila.',
	'dashboardMileage.placeholder.updated': 'unesi kilometražu (km)',
	'review.title': 'Sažetak digitalnog pregleda vozila',
	'review.paragraph.first':
		'Prije završetka provjeri jesu li svi podaci točni.<br/><br/>Nakon što klikneš „Završi”, provjerit ćemo tvoje fotografije i podatke.',
	'review.stepDescription.questions': 'Podaci o vozilu',
	'review.stepDescription.group.perspectiveImages': 'Pregled vozila',
	'review.stepDescription.group.additionalImages': 'Dodatne fotografije',
	'review.stepDescription.damageImages': 'Fotografije oštećenja',
	'review.stepDescription.vehicleFrontLeftPerspective':
		'Fotografija prednje lijeve dijagonale vozila',
	'review.stepDescription.vehicleRearLeftPerspective':
		'Fotografija stražnje lijeve dijagonale vozila',
	'review.stepDescription.vehicleRearRightPerspective':
		'Fotografija stražnje desne dijagonale vozila',
	'review.stepDescription.vehicleFrontRightPerspective':
		'Fotografija prednje desne dijagonale vozila',
	'review.stepDescription.windshield': 'Fotografija vjetrobranskog stakla',
	'review.stepDescription.vinPicture': 'Fotografija broja šasije',
	'review.stepDescription.overallDashboard': 'Fotografija cijele instrumentne ploče',
	'review.stepDescription.mileage': 'Fotografija brojača kilometara',
	'thanks.headline.first': 'Fotografije su uspješno zaprimljene!',
	'thankYou.message': 'Tvoj zahtjev trenutačno pregledavaju naši stručnjaci.',
	'feedback.title': 'Bilo bi nam drago čuti tvoje mišljenje.',
	'feedback.message':
		'Kako na ljestvici od 0 do 5 ocjenjuješ svoje iskustvo digitalnog pregleda vozila?',
	'feedback.helpImprove': 'Pomozi nam da budemo još bolji (neobavezno):',
	'feedback.button.send': 'Pošalji povratnu informaciju',
	'feedback.error.maxLength': 'Povratna informacija ne smije sadržavati više od 500 znakova.',
	'timeout.title': '',
	'timeout.headline.first': 'Traženi predmet nije pronađen.',
	'timeout.paragraph.first': 'Predmet je istekao ili je korištena neispravna poveznica.',
	'blockedByDevice.headline': 'Upotrijebite pametni telefon',
	'blockedByDevice.paragraph.first': 'Ova poveznica može se koristiti samo na pametnim telefonima.',
	'blockedByDevice.paragraph.second':
		'Savjet: Kada otvoriš poveznicu, budi u blizini vozila i pripremi dokumentaciju.',
	'photoUploading.title': 'Prijenos u tijeku',
	'photoAnalyzing.title': 'Analiza u tijeku',
	'photoLoading.title': 'Učitavanje u tijeku',
	'camera.darkWarning':
		'Okruženje je možda pretamno. Poboljšaj osvjetljenje kako bi kvaliteta fotografije bila bolja.',
	'landscapeModeDetected.title': 'Automatsko okretanje je uključeno',
	'landscapeModeDetected.text':
		'Za bolje iskustvo korištenja kamere isključi automatsko okretanje na svojem uređaju.',
	'validationContainer.correct': 'Ispravno',
	'button.changeImage': 'Promijeni fotografiju',
	'button.acceptImage': 'Prihvati fotografiju',
	'button.acceptMileage': 'Ispravno',
	'button.anotherImage': 'Fotografiraj ponovno',
	'invalidFile.size.title': 'Neispravna veličina fotografije',
	'invalidFile.size.description': 'Veličina fotografije veća je od dopuštene maksimalne veličine',
	'invalidFile.extension.title': 'Vrsta datoteke nije podržana',
	'invalidFile.extension.description':
		'Odabrana vrsta datoteke nije podržana. Podržane vrste datoteka su: .jpg, .jpeg, .jfif, .heic, .heif, .png i .bmp',
	'connectionError.title': 'Pogreška povezivanja',
	'connectionError.description':
		'Došlo je do pogreške pri povezivanju. Prenesi fotografiju ponovno.',
	'missingPhoto.title': 'Nedostaje fotografija',
	'missingPhoto.description':
		'Čini se da nedostaje fotografija. Za nastavak dodaj fotografiju koja nedostaje.',
};

export default messages;
